import type { ExtractPropTypes, PropType } from 'vue'
import type { FilterPayloadNode } from '@zoryn/components/grid'

export const rulesConditionsProps = {
  system: {
    type: String,
    required: true,
  },
  module: {
    type: String,
    default: undefined,
  },
  modelValue: {
    type: [Object, Array] as PropType<FilterPayloadNode | FilterPayloadNode[] | null>,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  /** 是否展示顶部逻辑描述卡片 */
  showSummary: {
    type: Boolean,
    default: true,
  },
} as const

export type RulesConditionsProps = ExtractPropTypes<typeof rulesConditionsProps>

export const rulesConditionsEmits = {
  'update:modelValue': (payload: FilterPayloadNode | FilterPayloadNode[] | null) =>
    payload === null || typeof payload === 'object',
  change: (payload: FilterPayloadNode | FilterPayloadNode[] | null) =>
    payload === null || typeof payload === 'object',
}
